import "./TeamsTabUI.css";

import { FC, useEffect, useMemo, useState } from "react";

import { Calendar } from "primereact/calendar";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { IAppState } from "../../../../../store/reducers";
import { InputText } from "primereact/inputtext";
import { TeamsService } from "../../../../../services/TeamsService";
import { TeamsTabToolbar } from "./TeamsTabToolbar/TeamsTabToolbar";
import { teamsInitialData } from "../../../EmployeeAssignemnt";
import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { useTheme } from "@mui/material";
import { EnhancedButtonPrimeReact, EnhancedButtonPrimeReactSeverity } from "@websential/cosmic-v20";
import { sortDDLByLabel } from "../../../../../common/Common";

// import { Button } from "primereact/button";

// import { Toolbar } from "primereact/toolbar";











let emptyTeam = {
	id: null,
	teams: "",
	fromDate: null,
	toDate: null,
	notes: "",
	rowWithRandomId: true
};

const useGetTeamsDDL = (clientId: string) =>
	useQuery({
		queryKey: ["teams-ddl", clientId],
		queryFn: () => {
			return TeamsService.getGetTeamsDDL(clientId);
		},
		refetchOnWindowFocus: false,
	});

interface ITeamsTabsPanel {
	teamsUpdatedData: (data: any) => void;
	teamsDataItems: any;
	TabTableheaderColumns: any;
	selectedEmployeeLabel: string;
	onRowDeleteClicked: (data: any) => void;
}
export const TeamsTabsPanel: FC<ITeamsTabsPanel> = ({
	teamsUpdatedData,
	teamsDataItems,
	TabTableheaderColumns,
	selectedEmployeeLabel,
	onRowDeleteClicked,
}) => {
	const theme = useTheme();
	const [teams, setTeams] = useState<any>(teamsDataItems);
	const [selectedTeams, setSelectedTeams] = useState<any>(null);
	const [team, setTeam] = useState(emptyTeam);
	const [lastAddedRowId, setLastAddedRowId] = useState<any>(null);

	const clientId = useSelector((state: IAppState) => state.client.id);
	const { data: teamsDDL, isLoading: isLoading } = useGetTeamsDDL(clientId);
	const teamsDDLItems = useMemo(() => {
		if (teamsDDL && Array.isArray(teamsDDL)) {
			let resources: any[] = sortDDLByLabel(teamsDDL).map((resourceItem: any) => ({
				id: resourceItem.id,
				label: resourceItem.label,
				value: resourceItem.value,
			}));
			resources.unshift({
				label: "--",
				value: null,
			});
			return resources;
		}
		return [
			{
				label: "--",
				value: null,
			},
		];
	}, [teamsDDL]);

	useEffect(() => {
		teamsUpdatedData(teams);
	}, [teams]);

	useEffect(() => {

		setTeams(teamsDataItems);
	}, [teamsDataItems]);

	const findIndexById = (id: string | number | any) => {
		let index = -1;

		for (let i = 0; i < teams.length; i++) {
			if (teams[i].id === id) {
				index = i;
				break;
			}
		}

		return index;
	};

	const createId = () => {
		let id = "";
		let chars =
			"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

		for (let i = 0; i < 5; i++) {
			id += chars.charAt(Math.floor(Math.random() * chars.length));
		}

		return id;
	};

	// const openNew = () => {
	// 	// alert("new")

	// 	let _teams = [...teams];
	// 	let _team: any = { ...team };

	// 	if (team.id) {
	// 		const index = findIndexById(team.id);

	// 		_teams[index] = _team;
	// 	} else {
	// 		_team.id = createId();
	// 		_teams.push(_team);
	// 	}



	// 	setTeams(_teams);
	// 	setTeam(emptyTeam);
	// };


	const openNew = () => {
		// if (employeeStatus && employeeStatus.length >= 4) return null;
		let _teamsSetupPanelData = [...teams];
		let _teamSetupPanelNewRow: any = { ...team };

		if (team.id) {
			const rowIndex = findIndexById(team.id);
			_teamsSetupPanelData[rowIndex] = _teamSetupPanelNewRow;

		} else {
			const newRowId = createId();
			_teamSetupPanelNewRow.id = newRowId;
			_teamsSetupPanelData.push(_teamSetupPanelNewRow);
			setLastAddedRowId(newRowId && newRowId);

		}
		setTeams(_teamsSetupPanelData);
		setTeam(emptyTeam);
	};

	const onCellValueChange = (event: any, rowIndex: number, field: any) => {
		// const updatedData = [...teams];
		// updatedData[rowIndex][event.field] = field;
		// setTeams(updatedData);

		setTeams((prev: any) => {
			const updatedData = [...prev];
			const updatedRow = { ...updatedData[rowIndex], [event.field]: field };
			updatedData[rowIndex] = updatedRow;
			return updatedData;
		});
	};

	const renderErrorClass = (field: any, rowIndex: number, rowData: any) => {
		if (field.field === "fromDate") {
			if (
				rowData.teams !== "" &&
				rowData.teams !== undefined &&
				rowData.teams !== null
			) {
				if (rowData.fromDate === null) {
					return "p-component p-filled calender-error-input";
				} else if (rowData.fromDate === "") {
					return "p-component p-filled calender-error-input";
				}
			}
		} else if (field.field === "teams") {
			if (
				rowData.fromDate !== "" &&
				rowData.fromDate !== undefined &&
				rowData.fromDate !== null
			) {
				if (rowData.teams === null) {
					return "p-component p-filled input-dropdown-fields .p-dropdown dropdown-error-input";
				} else if (rowData.teams === "") {
					return "p-component p-filled input-dropdown-fields .p-dropdown dropdown-error-input";
				}
			} else {
				return "p-component p-filled input-dropdown-fields .p-dropdown";
			}
		} else {
			return "p-component p-filled input-dropdown-fields";
		}
	};

	const columnsBody = (rowData: any, row: any, x: any) => {
		if (x.field === "label") {
			return (
				<span>
					<b>
						Select Team 
					</b>
				</span>
			);
		} else if (x.field === "teams") {
			return (
				<Dropdown
					options={teamsDDLItems}
					value={rowData.teams}
					onChange={(e: any) =>
						onCellValueChange(x, row.rowIndex, e.target.value)
					}
					placeholder="--"
					className={renderErrorClass(x, row.rowIndex, rowData)}
				/>
			);
		} else if (x.field === "fromDate") {
			return (
				<Calendar
					id="fromDate"
					value={rowData[x.field]}
					showIcon
					// className="calender"
					style={{ height: "2.6rem", margin: "8px 0px 4px 0px", width: "auto" }}
					onChange={(e: any) => onCellValueChange(x, row.rowIndex, e.value)}
					dateFormat="M dd, yy"
					placeholder={"dd/mm/yyyy"}
					className={`calender ${renderErrorClass(x, row.rowIndex, rowData)}`}
				/>
			);
		} else if (x.field === "toDate") {
			return (
				<Calendar
					id="toDate"
					value={rowData[x.field]}
					showIcon
					className="calender"
					style={{ height: "2.6rem", margin: "8px 0px 4px 0px", width: "auto" }}
					onChange={(e: any) => onCellValueChange(x, row.rowIndex, e.value)}
					dateFormat="M dd, yy"
					placeholder={"dd/mm/yyyy"}
				/>
			);
		} else if (x.field === "notes") {
			return (
				<InputText
					value={rowData[x.field]}
					onChange={(e: any) =>
						onCellValueChange(x, row.rowIndex, e.target.value)
					}
					placeholder="Write notes here"
					className={"notesField p-component p-filled input-dropdown-fields"}
				/>
			);
		}
	};



	const onDeleteNewAddedRow = (rowId: any) => {
		setTeams((prev: any[]) => {
			const rowDeleteBasedOnId = prev.filter((row) => row.id !== rowId);

			if (rowDeleteBasedOnId.length > 1) {
				const lastRowId = rowDeleteBasedOnId[rowDeleteBasedOnId.length - 1].id;
				setLastAddedRowId(lastRowId);
			} else {
				setLastAddedRowId(null);
			}
			return rowDeleteBasedOnId;
		});
	}

	return (
		<>
			{teamsDDL ? (
				<div className="card">
					<TeamsTabToolbar
						openNew={openNew}
						selectedEmployeeLabel={selectedEmployeeLabel}
					/>
					<DataTable
						value={teams}
						// key={JSON.stringify(teamsDDLItems)}
						dataKey="id"
						key={lastAddedRowId}
						showGridlines
						className="TeamsTab"
						editMode="cell"
						resizableColumns
						columnResizeMode="expand"
						scrollable
						// reorderableColumns
						filterDisplay="menu"
						scrollHeight="516px"
						loading={isLoading}
					>
						{TabTableheaderColumns.map((x: any, index: any) => {
							return (
								<Column
									key={index}
									field={x.field}
									header={x.headerName}
									headerTooltip={x.description}
									headerTooltipOptions={{ position: "top" }}
									sortable={false}
									// resizeable={x.resizable}
									// dataType={x.type}
									align={x.align}
									alignHeader={x.headerAlign}
									reorderable={false}
									// exportable={x.disableExport}
									frozen={x.frozenColumn}
									columnKey={x.field}
									style={{
										width: x.minWidth,
										fontSize: "0.875rem",
									}}
									footer={x.footer}
									body={(rowData: any, row: any) =>
										columnsBody(rowData, row, x)
									}
								/>
							);
						})}

						{/* <Column
									body={(rowData: any, row: any) => {
									  const showIcon = rowData.id === lastAddedRowId;
									  return showIcon ? (
										<EnhancedButtonPrimeReact
										  icon="pi pi-times"
										  severity={EnhancedButtonPrimeReactSeverity.Danger}
										  className="p-button-rounded p-button-text shadow-none bg-transparent"
										  rounded
										  // onClickHandler={onDeleteNewAddedRow}
										  onClickHandler={() => onDeleteNewAddedRow(rowData.id)}
										/>
									  ) : null;
									}}
								  /> */}

						<Column
							body={(rowData: any, row: any) => {
								const isLastRow = row.rowIndex === teams.length - 1;
								console.log("isLastRow", isLastRow)
								return isLastRow ? (
									<EnhancedButtonPrimeReact
										icon="pi pi-times"
										severity={EnhancedButtonPrimeReactSeverity.Danger}
										className="p-button-rounded p-button-text shadow-none bg-transparent  delete-row-btn"
										rounded
										onClickHandler={() => rowData.rowWithRandomId ? onDeleteNewAddedRow(rowData.id) : onRowDeleteClicked(rowData)}
									/>
								) : null;
							}}
						/>

					</DataTable>
				</div>
			) : (
				<></>
			)}
		</>
	);
};
